export function formatNumber(value: number) {
  return Number(value).toLocaleString();
}
